module.exports = __webpack_public_path__ + "static/solution7-fe51fc2efe33024a55c961f4bdb6ac92.png";